import { rem } from 'polished'
import styled from 'styled-components'

import Icon from '../helpers/Icon'

export const BadgeIcon = styled(Icon)`
  margin-right: 8px;
`

export const BadgeLabel = styled.h1`
  text-transform: uppercase;
  color: ${({ theme, color }) => theme.color[color]};
  font-weight: 700;
  font-size: ${rem(14)};
  letter-spacing: 0.5px;
`

export const BadgeWrapper = styled.div`
  display: flex;
  align-items: center;

  ${({ orientation }) =>
    orientation === 'vertical' &&
    `
    flex-direction: column;

    ${BadgeIcon} {
      margin-bottom: 8px;
    }
  `}
`
